<template>
  <div class="wrapper">
    <img v-if="pageType=='1'" class="topImg" src="../../assets/images/rank/hotTopBg.png" alt="">
    <img v-if="pageType=='2'" class="topImg" src="../../assets/images/rank/liveTopBg.png" alt="">
    <div class="listBox">
      <div class="tabBox" v-if="pageType=='1'">
        <div :class="{tabItem:true, active:activeTab=='0'}" @click.stop="changeTab('0')">
          <span>今日榜单</span>
        </div>
        <div :class="{tabItem:true, active:activeTab=='1'}" @click.stop="changeTab('1')">
          <span>昨日榜单</span>
        </div>
      </div>
      <div class="tabBox" v-if="pageType=='2'">
        <div :class="{tabItem:true, active:true}">
          <span>直播好物推荐榜</span>
        </div>
      </div>
      <van-list style="background:transparent;padding-top:.2rem ;" v-model="loading" :finished="finished"
        @load="loadMore" :offset="20">
        <div class="item" v-for="(item,index) in list" :key="index" @click="golistdetail(item.nbr, item.rule_type)">
          <img class="itemImg" v-lazy="item.commodity_logo" alt>
          <div class="itemRight">
            <img class="hotImg" v-if="pageType=='1'" src="../../assets//images/rank/hotTip.png" alt="">
            <img class="liveImg" v-if="pageType=='2'" src="../../assets//images/rank/liveTip.png" alt="">
            <p class="name">{{item.commodity_name}}</p>
            <div class="priceBox">
              <span class="priceTip">￥</span>
              <span class="price"
                v-if="item.rule_type=='1'">{{roleText.toLocaleLowerCase()=='sell'&&item.show_price?item.show_price:item[`min_${roleText.toLocaleLowerCase()}_price`]}}</span>
              <span class="price"
                v-if="item.rule_type=='2'">{{newRoleText.toLocaleLowerCase()=='sell'&&item.show_price?item.show_price:item[`min_${newRoleText.toLocaleLowerCase()}_price`]}}</span>
              <span class="oldPrice">￥{{item.old_price}}</span>
            </div>
            <img class="cartImg" src="../../assets/images/rank/rankCart.png" alt="" @click.stop="showSpec(item.nbr)">
          </div>
        </div>
      </van-list>
    </div>

    <!-- 规格弹窗 -->
    <div class="guige-popup" v-show="specShow">
      <van-popup v-model="specShow" position="bottom" :overlay="true" class="guigepopup">
        <!--<div class="guige-popupbox">-->
        <div class="guige-popupt">
          <div class="guige-popuptl">
            <div class="guige-popuptll">
              <img @click="showImage(assessmentDetail.inventoryLogo)" v-if="assessmentDetail.inventoryLogo"
                :src="assessmentDetail.inventoryLogo + `${imgCrop}resize,w_300`" alt />
              <img @click="showImage(goods_detail.commodityLogo)" v-else
                :src="goods_detail.commodityLogo+`${imgCrop}resize,w_300`" alt />
            </div>
            <div class="guige-popuptlr">
              <p v-if="assessmentDetail[`${roleText.toLocaleLowerCase()}Price`]">
                ￥{{assessmentDetail[`${goods_detail.ruleType=='1'?roleText.toLocaleLowerCase():newRoleText.toLocaleLowerCase()}Price`]}}
              </p>
              <p v-else>￥{{goods_detail[`min${goods_detail.ruleType=='1'?roleText:newRoleText}Price`]}}</p>
              <p v-if="goods_detail.isQuantityShow==1&&assessmentDetail.quantity">库存：{{assessmentDetail.quantity}}</p>
              <p v-else-if="goods_detail.isQuantityShow==1">库存：{{quantity}}</p>
              <p v-else> </p>
              <p v-show="guigeCount==selectArr.length"><span>请选择</span></p>
              <p v-show="guigeCount!=selectArr.length"><span>已选：</span><span class="grey">{{guige}}</span></p>
            </div>
          </div>
          <div class="guige-popuptr" @click="specShow = false;">
            <img src="../../assets/images/icon_close.svg" alt />
          </div>
        </div>
        <div class="guige-popupc-wrap">
          <div class="guige-popupc" v-for="(item,n) in propertyListJson" :key="n">
            <div class="guige-popupct">{{item.name}}</div>
            <div class="guige-popupcc">
              <div class="guige-popupccm" v-for="(items,index) in item.children" :key="index"
                v-on:click="specificationBtn(item.name,items.name,items.quantity)"
                v-bind:class="items.quantity == 0?'nostock':
                [JSON.stringify(selectArr).indexOf(JSON.stringify({key:item.name,value:items.name}))!=-1?'productActive':'']"><span>{{items.name}}</span></div>
              <!--noneActive-->
            </div>
          </div>
        </div>
        <div class="guige-popupn">
          <div class="guige-popupnl">
            数量
            <span v-if="goods_detail.limitQuantity>0">(每个ID限购{{goods_detail.limitQuantity}}件)</span>
          </div>
          <div class="guige-popupnr">
            <span :style="{'color':'#999'}" v-if="quantity==0">-</span>
            <span @click="changeNum(-assessmentDetail.addStep)" :style="{'color':(lowPriceStyle?'#999':'')}"
              v-else>-</span>
            <input :style="{'background':'#fff'}" type="number" v-model="num" @blur="blurChange" v-if="quantity==0"
              disabled />
            <input type="number" v-model="num" @blur="blurChange" v-else />
            <span :style="{'color':'#999'}" v-if="quantity==0">+</span>
            <span @click="changeNum(assessmentDetail.addStep)" :style="{'color':(highPriceStyle?'#999':'')}"
              v-else>+</span>
          </div>
        </div>
        <div class="guige-popupnb">
          <div class="guige-popupnbl" @click="gocart">确定</div>
        </div>
        <!--</div>-->
      </van-popup>
    </div>
  </div>
</template>

<script>
  import weChatShareApi from "../../assets/js/weChatShare";
  export default {
    components: {},
    props: {},
    mixins: [weChatShareApi],
    data() {
      return {
        pageType: '',
        title: "",
        activeTab: '0',
        nbr: '',
        list: [],
        loading: false, //上拉加载
        finished: false, //加载完成
        pageIndex: 0,
        canAdd: false,
        numPerPage: 10,
        roleText: "Sell",
        newRoleText: "Sell",
        keepAlive: true,
        isLoading: false,
        scroll: 0,
        option: {},

        specShow: false, // 规格弹窗
        assessmentDetail: {},
        propertyListJson: [], //规格属性
        goods_detail: {},
        quantity: 0,
        guigeCount: 0, // 规格未选择数
        quantityArr: [], // 为库存为0数组
        selectArr: [], //存放被选中的值
        guige: "请选择", //已选规格
        num: 1, //加减数量
        goodNbr: '', // 点击的商品nbr
        lowPriceStyle: true, // 加减价格样式
        highPriceStyle: false,
      };
    },
    watch: {
      $route(to, from) {
        if (
          from.path == "/index"
        ) {
          this.keepAlive = true;
        } else {
          this.keepAlive = false;
        }
      }
    },
    computed: {
    },
    methods: {
      changeTab(index) {
        this.activeTab = index
        if (this.pageType == '1') {
          this.nbr = index == '0' ? '854' : '855'
        } else {
          this.nbr = '856'
        }
        this.pageIndex = 0;
        this.getData([]);
      },
      checkOption() {
        if (!(this.userInfo && this.userInfo.nbr)) {
          this.roleText = 'Sell';
          this.newRoleText = 'Sell';
        } else {
          this.getUserInfo();
        }
        this.option.title && this.list.length > 0 && this.weChatShare(this.option);
      },
      refresh() {
        this.finished = true;
        this.pageIndex = 0;
        this.getData([]);
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      },
      golistdetail(nbr, rule_type) {
        if (rule_type == '2') {
          this.$router.push({ path: "/sourceListdetail", query: { nbr: nbr, supNbr: this.userInfo.nbr } });
        } else {
          this.$router.push({ path: "/listdetail", query: { nbr: nbr, supNbr: this.userInfo.nbr } });
        }
      },
      loadMore() {
        if (this.finished) {
          return false;
        }
        if (this.canAdd) {
          this.loading = true;
          this.pageIndex++;
          this.getData(this.list);
        }
      },
      getData(oldList) {
        let that = this
        this.$commonPost({
          jydm: "flow_70253",
          flow_70253: {
            area_nbr: this.nbr,
            page_index: this.pageIndex * this.numPerPage,
            num_per_page: this.numPerPage,
            type: -1
          }
        }).then(response => {
          let arr = [];
          if (response.commodity) {
            if (response.commodity.length > 0) {
              arr = response.commodity;
            } else {
              arr.push(response.commodity);
            }
          }
          if (this.pageIndex == 0) {
            that.option = {
              title: response.share_title || response.area_title,
              desc: response.share_desc || '',
              link: `${location.origin}/rankList?type=${this.pageType}&supNbr=${this.userInfo.nbr}`,
              images: response.share_image || response.image_path,
            }
            setTimeout(() => {
              that.weChatShare(that.option);
            }, 500)
          }
          this.list = oldList.concat(arr);
          this.canAdd = arr.length >= this.numPerPage;
          this.loading = false;
          if (arr.length < this.numPerPage) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        }).catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      },
      getUserInfo() {
        // 用户的基本信息(身份)
        this.$commonPost({
          jydm: "flow_10003",
          flow_10003: {
            user_nbr: this.userInfo.nbr
          }
        }).then(response => {
          this.info = response;
          if (response.role == 0 || response.role == 1) {
            this.roleText = "Sell";
          } else if (response.role == 2) {
            this.roleText = "Agent";
          } else if (response.role == 3) {
            this.roleText = "Director";
          }
          if (response.new_role == 0 || response.new_role == 1) {
            this.newRoleText = "Sell";
          } else if (response.new_role == 2) {
            this.newRoleText = "Agent";
          } else if (response.new_role == 3) {
            this.newRoleText = "Director";
          }
        }).catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      },
      showImage(img) {
        wx.previewImage({
          current: img,
          urls: [img]
        })
      },
      getCommodityNum(nbr) {
        this.$commonPost({
          jydm: "flow_70059",
          flow_70059: {
            nbr: nbr,
            wechat_version: 1
          }
        }).then(response => {
          this.quantity = response.commodity.quantity;
        }).catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      },
      showSpec(nbr) {
        this.goodNbr = nbr;
        this.guigeCount = 0;
        let toast = this.$toast.loading({
          mask: false,
          duration: 0
        });
        this.assessmentDetail = {};
        this.$post("/api/customer/queryCommodityDetail", {
          commodityNbr: nbr
        }).then(res => {
          let arr = [];
          let data = res.object.resp.commodity;
          let text = "";
          let propertyArr = [];
          if (res.code == "200") {
            let resp = res.object.resp;
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              if (data.commodityLogoList) {
                arr = data.commodityLogoList.split(",");
              }
              this.getCommodityNum(data.nbr)
              data.endTime = data.endTime.slice(0, 19);
              this.goods_detail = data;
              this.images = arr;
              this.propertyListJson = data.propertyJson;
              let commodityInventoryList = data.commodityInventoryList;
              if (commodityInventoryList.length == 1 && commodityInventoryList[0].quantity > 0) {
                commodityInventoryList[0].propertyListJson.map((item, j) => {
                  if (j == 0) {
                    text = item.propertyValue;
                  } else {
                    text += "," + item.propertyValue;
                  }
                  let obj = {
                    key: item.propertyName,
                    value: item.propertyValue
                  };
                  propertyArr.push(obj);
                })
                this.guigeCount = 0;
              } else {
                this.guigeCount = data.propertyJson.length;
                data.propertyJson.map((item, j) => {
                  let obj = {
                    key: item.name,
                    value: ''
                  };
                  propertyArr.push(obj);
                })
              }
              this.guige = text;
              this.selectArr = propertyArr;
              this.checkItem(propertyArr);
              this.checkNoClick();
              this.thisCheckNoClick(propertyArr);
              toast.clear();
              this.specShow = true;
            } else {
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
            }
          } else {
            this.$toast({
              message: resp.message,
              duration: 2000
            });
          }
        }).catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      },
      gocart() {
        let userNbr = this.userInfo.nbr;
        if (this.quantity == 0) {
          return this.$toast({
            message: '该商品库存为0',
            duration: 2000
          });
        }
        if (this.guigeCount == 0) {
          this.$commonPost({
            jydm: "flow_10000",
            flow_10000: {
              sub_flow: "flow_30001",
              user_nbr: userNbr,
              commodity_nbr: this.goodNbr,
              inventory_nbr: this.assessmentDetail.nbr,
              quantity: this.num
            }
          })
            .then(response => {
              this.specShow = false;
              this.$toast({
                message: "已加入购物车！",
                duration: 2000
              });
            })
            .catch(err => {
              this.$toast({
                message: err.message,
                duration: 2000
              });
            });
        } else {
          this.$toast({
            message: '请选择规格',
            duration: 2000
          });
        }
      }, specificationBtn: function (key, value, num) {
        let text = "";
        let selectArr = this.selectArr;
        if (num == 0) {
          return this.$toast({
            message: "该规格库存为0",
            duration: 2000
          });
        }
        selectArr.map((item, index) => {
          if (item.key == key) {
            if (item.value == value) {
              selectArr[index].value = '';
            } else {
              selectArr[index].value = value;
            }
          }
        });
        let dIndex = 0;
        for (let i = 0; i < selectArr.length; i++) {
          if (selectArr[i].value != '') {
            if (i == dIndex) {
              text = selectArr[i].value;
            } else {
              text += "," + selectArr[i].value;
            }
          } else {
            dIndex += 1;
          }
        }
        let assessmentDetail = this.assessmentDetail;
        let goods_detail = this.goods_detail;
        let propertyListJson = this.propertyListJson;
        let checkPriceChange = this.checkPriceChange;
        let count = 0;
        selectArr.map(item => {
          if (item.value == '' || !item.value) {
            count += 1;
          }
        })
        let inventoryList = []
        if (count == selectArr.length) {
          assessmentDetail.minimumSellNum = 1;
          assessmentDetail.addStep = 1;
          assessmentDetail.inventoryLogo = goods_detail.commodityLogo;
          assessmentDetail.directorPrice = checkPriceChange(goods_detail.minDirectorPrice, goods_detail.maxDirectorPrice);
          assessmentDetail.agentPrice = checkPriceChange(goods_detail.minAgentPrice, goods_detail.maxAgentPrice);
          assessmentDetail.sellPrice = checkPriceChange(goods_detail.minSellPrice, goods_detail.maxSellPrice);
          assessmentDetail.quantity = this.quantity;
          this.assessmentDetail = assessmentDetail;
        } else if (count > 0) {
          let propertyList = this.goods_detail.commodityInventoryList
          let propertyArr = [];
          for (let a = 0; a < selectArr.length; a++) {
            if (selectArr[a].value) {
              let aItem = {
                propertyName: selectArr[a].key,
                propertyValue: selectArr[a].value
              };
              propertyArr.push(aItem);
            }
          }
          for (let b = 0; b < propertyList.length; b++) {
            let bItem = propertyList[b].propertyListJson;
            let count = 0;
            for (let c = 0; c < propertyArr.length; c++) {
              if (
                JSON.stringify(bItem).indexOf(JSON.stringify(propertyArr[c])) != -1
              ) {
                count += 1;
              }
            }
            if (count == propertyArr.length) {
              inventoryList.push(propertyList[b]);
            }
          }
          this.assessmentDetail = JSON.parse(JSON.stringify(inventoryList[0]))
        } else {
          this.checkItem(selectArr);
        }
        this.thisCheckNoClick(selectArr);
        this.guigeCount = count;
        this.guige = text;
        this.selectArr = selectArr;
      },
      checkPriceChange(a, b) {
        if (a == b) {
          return a;
        } else {
          return a + '-' + b;
        }
      },
      thisCheckNoClick(selectArr) {
        let quantityArr = this.quantityArr;
        let propertyListJson = this.propertyListJson;
        propertyListJson.map((json, index1) => {
          json.children.map((child, index2) => {
            let arr = [];
            arr.length = propertyListJson.length;
            arr[index1] = {
              propertyName: json.name,
              propertyValue: child.name,
            }
            selectArr.map((select, index3) => {
              if (index3 != index1) {
                arr[index3] = {
                  propertyName: select.key,
                  propertyValue: select.value,
                }
              }
            });
            if (JSON.stringify(quantityArr).indexOf(JSON.stringify(arr)) > 0) {
              child.quantity = 0;
            } else {
              child.quantity = 1;
            }
          })
        })
        this.propertyListJson = propertyListJson;
      },
      checkItem: function (selectArr) {
        let propertyArr = [];
        let propertyList = this.goods_detail.commodityInventoryList;
        for (let a = 0; a < selectArr.length; a++) {
          let aItem = {
            propertyName: selectArr[a].key,
            propertyValue: selectArr[a].value
          };
          propertyArr.push(aItem);
        }
        for (let b = 0; b < propertyList.length; b++) {
          let bItem = propertyList[b].propertyListJson;
          let count = 0;
          for (let c = 0; c < propertyArr.length; c++) {
            if (
              JSON.stringify(bItem).indexOf(JSON.stringify(propertyArr[c])) != -1
            ) {
              count += 1;
            }
          }
          if (count == bItem.length) {
            this.assessmentDetail = JSON.parse(JSON.stringify(propertyList[b]));
            this.num = this.assessmentDetail.minimumSellNum;
          }
        }
        this.$forceUpdate(); //重绘
      },
      checkNoClick: function () {
        let propertyList = this.goods_detail.commodityInventoryList;
        let quantityArr = [];
        for (let i = 0; i < propertyList.length; i++) {
          if (propertyList[i].quantity == 0) {
            let propertyComplete = propertyList[i].propertyListJson;
            quantityArr.push(propertyComplete);
          }
        }
        this.quantityArr = quantityArr;
      },
      blurChange() {
        this.checkNum()
        window.scrollTo(0, 0);
      },
      checkNum() {
        let value = this.num;
        let assessmentDetail = this.assessmentDetail;
        let limitQuantity = this.goods_detail.limitQuantity
        this.highPriceStyle = false;
        this.lowPriceStyle = false;
        if (JSON.stringify(assessmentDetail) == '{}') {
          assessmentDetail = {
            minimumSellNum: 1,
            addStep: 1,
            quantity: this.goods_detail.totalQuantity
          }
        }
        if (!value || value == '' || value <= assessmentDetail.minimumSellNum) {
          value = assessmentDetail.minimumSellNum;
          this.lowPriceStyle = true;
        }
        if (limitQuantity > 0) {
          if (value >= limitQuantity) {
            let low = (limitQuantity - assessmentDetail.minimumSellNum) % assessmentDetail.addStep;
            value = limitQuantity - low;
            this.highPriceStyle = true;
          } else {
            value = value - ((value - assessmentDetail.minimumSellNum) % assessmentDetail.addStep);
          }
        }
        else {
          if (value > assessmentDetail.quantity) {
            let low = (assessmentDetail.quantity - assessmentDetail.minimumSellNum) % assessmentDetail.addStep;
            value = assessmentDetail.quantity - low;
            this.highPriceStyle = true;
          } else {
            value = value - ((value - assessmentDetail.minimumSellNum) % assessmentDetail.addStep);
          }
          console.log(value);
        }
        this.num = parseInt(value);
      },
    },
    created() {
    },
    mounted() {
    },
    // 被缓存时任执行
    activated() {
      this.pageType = this.$route.query.type;
      document.title = this.pageType == '1' ? "今日热销排行榜" : this.pageType == '2' ? "直播好物推荐榜" : '';
      if (!this.keepAlive) {
        return false;
      } else {
        this.changeTab('0');
      }
      this.checkOption();
    },
    beforeRouteLeave(to, from, next) {
      next();
    }
  };
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
  .wrapper {
    width: 100%;
    min-height: 100vh;
    background: #fce4b7;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .topImg {
    width: 100%;
    height: 4.38rem;
  }

  .listBox {
    width: 7.1rem;
    border-radius: .2rem;
    background: #fff;
    margin-bottom: .2rem;
    overflow: hidden;
  }

  .tabBox {
    width: 7.1rem;
    height: 1.04rem;
    display: flex;
    flex-direction: row;
    align-items: center;

    .tabItem {
      flex: 1;
      height: 1.04rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      background: #FFF4DE;
      ;

      span {
        font-size: .32rem;
        color: #333;
        font-weight: 400;
      }

      &.active {
        background: #fff;

        span {
          font-weight: 600;
        }
      }
    }
  }

  /* 商品列表 */
  .item {
    width: 7.1rem;
    box-sizing: border-box;
    padding: 0 .2rem .2rem .2rem;
    display: flex;
    flex-direction: row;

    .itemImg {
      width: 2.34rem;
      height: 2.34rem;
      background: #FFF4DE;
      border-radius: .2rem;
      margin-right: .2rem;
    }

    .itemRight {
      width: 4.16rem;
      display: flex;
      flex-direction: column;
      position: relative;

      .hotImg {
        width: .92rem;
        height: .5rem;
        margin-bottom: .1rem;
      }

      .liveImg {
        width: .92rem;
        height: .5rem;
        margin-bottom: .1rem;
      }

      .name {
        height: 0.8rem;
        line-height: 0.4rem;
        font-size: 0.28rem;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        line-clamp: 2;
        word-break: break-all;
        white-space: normal;
        margin-bottom: .2rem;
      }

      .priceBox {
        height: .65rem;
        display: flex;
        flex-direction: row;
        align-items: baseline;

        .priceTip {
          font-size: .28rem;
          color: #333;
          font-weight: 400;
        }

        .price {
          font-size: .46rem;
          color: #333;
          font-weight: 400;
        }

        .oldPrice {
          font-size: .24rem;
          color: #999;
          text-decoration: line-through;
          margin-left: 0.2rem;
        }
      }

      .cartImg {
        position: absolute;
        right: .2rem;
        bottom: .38rem;
        z-index: 1;
        width: .46rem;
        height: .46rem;
      }
    }
  }

  /* 规格弹窗 */
  .guige-popup {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: flex-end;
    width: 100%;
  }

  .guige-popupbox {
    margin-top: calc(100vh - 9.48rem);
    background: #ffffff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .guige-popupt {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 0.24rem;
    margin-top: 0.24rem;
  }

  .guige-popuptl {
    display: flex;
    flex-direction: row;
  }

  .guige-popuptlr {
    margin-left: 0.24rem;
  }

  .guige-popuptlr p:nth-of-type(1) {
    color: #E52B25;
    font-size: 0.4rem;
    margin-top: 0.1rem;
  }

  .guige-popuptlr p:nth-of-type(2) {
    font-size: 0.24rem;
    margin-top: 0.1rem;
    line-height: 0.35rem;
    color: #999;
  }

  .guige-popuptlr p:nth-of-type(3) {
    font-size: 0.24rem;
    margin-top: 0.1rem;
    width: 4.72rem;
    line-height: 0.35rem;
    display: flex;
    justify-content: flex-start;

    span {
      height: 100%;
    }
  }

  .guige-popuptlr p:nth-of-type(4) {
    font-size: 0.24rem;
    margin-top: 0.1rem;
    width: 4.72rem;
    line-height: 0.35rem;
    display: flex;
    justify-content: flex-start;

    span {
      height: 100%;
    }
  }

  .guige-popuptr {
    position: absolute;
    top: .24rem;
    right: .24rem;

    img {
      width: 0.4rem;
    }
  }

  .guige-popuptr img {
    width: 0.4rem;
    height: 0.4rem;
  }

  .guige-popuptll img {
    width: 2rem;
    height: 2rem;
    border-radius: 0.08rem;
  }

  .guige-popupc-wrap {
    width: 100%;
    margin-top: 0.2rem;
    height: 4.8rem;
    overflow-y: auto;
  }

  .guige-popupct {
    font-size: 0.28rem;
    margin-left: 0.24rem;
    margin-top: 0.4rem;
  }

  .guige-popupcc {
    width: calc(100% - .24rem);
    margin-left: .12rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .guige-popupccm {
    padding: 0.05rem 0.25rem;
    box-sizing: border-box;
    background: #fff;
    border-radius: 0.5rem;
    margin-right: 0.12rem;
    margin-left: 0.12rem;
    margin-top: 0.24rem;
    border: 1px solid #999;
    font-size: 0.24rem;
    line-height: .34rem;

    span {
      display: inline-block;
      line-height: 0.34rem;
      word-break: break-all;
    }

    ;
  }

  .guige-popupcc .productActive {
    background-color: #E52B25 !important;
    color: #fff !important;
    border: 1px solid #E52B25 !important;
    box-sizing: border-box;
  }

  .guige-popupcc .noneActive {
    background-color: #ccc !important;
    opacity: 0.4 !important;
    color: #000 !important;
    pointer-events: none !important;
  }

  .guige-popupn {
    margin: 0 0.24rem .28rem;
    height: 1.08rem;
    line-height: 1.08rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: #fff;
    position: relative;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    align-items: center;
  }

  .guige-popupnb {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /*position: absolute;*/
    /*bottom: 0;*/
    /*left: 0;*/
    margin-top: 0.12rem;
  }

  .guigepopup {
    border-top-left-radius: .3rem;
    border-top-right-radius: .3rem;
  }

  .guige-popupnbl {
    width: 100%;
    text-align: center;
    line-height: 1.08rem;
    font-size: 0.3rem;
    color: #fff;
    background: #E52B25;
  }

  .guige-popupnbr {
    width: 3.8rem;
    text-align: center;
    line-height: 1.08rem;
    font-size: 0.3rem;
    color: #fff;
    background: #E52B25;
  }

  .guige-popupnbr-no {
    width: 3.8rem;
    text-align: center;
    line-height: 1.08rem;
    font-size: 0.3rem;
    color: #fff;
    background: #cccccc;
  }

  .guige-popupnl span {
    margin-left: 0.2rem;
    color: #999;
  }

  .guige-popupnr {
    border-radius: .29rem;
    border: 1px solid #999;
    height: 0.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.2rem;
  }

  .guige-popupnr span {
    display: inline-block;
    width: 0.6rem;
    height: 0.58rem;
    text-align: center;
    line-height: 0.58rem;
    vertical-align: middle;
    border-right: none;
  }

  .guige-popupnr input {
    width: 1rem;
    line-height: 0.58rem;
    text-align: center;
    outline: 0;
    padding-top: 0.01rem;
    vertical-align: middle;
    border: none;
    border-radius: 0;
    border-left: 1px solid #999;
    border-right: 1px solid #999;
    box-sizing: border-box;
  }
</style>


// WEBPACK FOOTER //
// src/components/index/rankList.vue